import { defaultsDeep } from "lodash";
import { DeepNullableObj, EventContext } from "../types";
import { MockFn, createMock } from "./index";

const mockEventContext: MockFn<Partial<DeepNullableObj<EventContext>>> = (
  args,
) =>
  defaultsDeep(
    args,
    createMock(
      "EventContext",
      args,
      (_shallow): DeepNullableObj<EventContext> => ({
        __typename: "EventContext",
        accepted_solutions: null,
        ahb_form: {
          approved_by: null,
          insurance_name: null,
          withdraw_reason: null,
          withdraw_reason_other: null,
        },
        arrival_time: null,
        bounced_mails: {
          bounced_emails: null,
          total_bounced: null,
          total_sent: null,
        },
        capacity_confirmed: null,
        capacity_date: null,
        careprovider_name: null,
        clinic_internal_remarks: null,
        declined_reason: null,
        diff: null,
        eligibility_reject_reason: null,
        email: null,
        file: null,
        file_scope: null,
        file_type: null,
        filters: null,
        form_type: null,
        insurance_name: null,
        mail_type: null,
        manual: null,
        message: null,
        message_iv: null,
        new_assignee_name: null,
        new_roles: null,
        new_stations: null,
        new_status: null,
        no_capacity_expiration: null,
        no_capacity_reasons: null,
        old_assignee_name: null,
        onboarding_comment: null,
        onboarding_email_type: null,
        patient_type: null,
        possible_entry_date: null,
        previous_status: null,
        reason: null,
        recipients: null,
        reha_form_status: null,
        request_link: null,
        request_unavailable_reason: null,
        seald_message: null,
        solution_filter_reasons: null,
        stop_description: null,
        stop_reason: null,
        transferred_to_specialization: null, // 1
        user_id: null,
        winning_solution: null, // 1
      }),
    ),
  );

export default mockEventContext;
